import { render, staticRenderFns } from "./DenunciaDetalhe.vue?vue&type=template&id=679665fc&lang=pug"
import script from "./DenunciaDetalhe.vue?vue&type=script&lang=js"
export * from "./DenunciaDetalhe.vue?vue&type=script&lang=js"
import style0 from "./DenunciaDetalhe.vue?vue&type=style&index=0&id=679665fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports